import { useTranslation } from 'next-i18next'

import Slider from '@/components/slider'
import Testimonial from '@/components/testimonial'

import { felipeLais, klaus, rob, rosemaire, wBrothers } from './avatars'

const Testimonials = () => {
  const { t } = useTranslation('about')
  const renter = t('about:Renter')
  const renters = t('about:Renters')
  const landlord = t('about:Landlord')
  const propertyManager = t('about:Property Manager')

  return (
    <Slider
      label={(key: string) =>
        t('about:testimonial.key', {
          defaultValue: 'Testimonial {{key}}',
          key
        })
      }
    >
      <Testimonial
        name={t('about:testimonial_1.name')}
        title={renter}
        avatar={rosemaire}
      >
        {t(
          'about:testimonial_1.text',
          'The best thing about liv.rent is the verified listings; I noticed this during my first search and since then, I’ve used liv.rent exclusively.'
        )}
      </Testimonial>
      <Testimonial
        name={t('about:testimonial_2.name')}
        title={renters}
        avatar={felipeLais}
      >
        {t(
          'about:testimonial_2.text',
          'It took only 3 days to find and secure the rental using liv.rent'
        )}
      </Testimonial>
      <Testimonial
        name={t('about:testimonial_3.name')}
        title={propertyManager}
        avatar={klaus}
      >
        {t(
          'about:testimonial_3.text',
          'As a Property Manager, I like how easy it is for tenants to apply for a rental, and for us to review all the pertinent information in one place.'
        )}
      </Testimonial>
      <Testimonial
        name={t('about:testimonial_4.name')}
        title={landlord}
        avatar={rob}
      >
        {t(
          'about:testimonial_4.text',
          "It's seamless, concise, covers so much, such as all pertinent info to do with a lease, amendments and able to send it electronically to your new tenant...I will now see a landlording in a different way."
        )}
      </Testimonial>
      <Testimonial
        name={t('about:testimonial_5.name')}
        title={propertyManager}
        link="https://www.youtube.com/watch?v=9Z_dwJgJrec"
        avatar={wBrothers}
      >
        {t(
          'about:testimonial_5.text',
          'It has helped us tremendously to save time and effort in communication. We can do everything on their platform.'
        )}
      </Testimonial>
    </Slider>
  )
}

export default Testimonials
